import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { css, cx } from '@emotion/css';
import { ChevronDown, ChevronUp, Calendar } from 'react-feather';
import { IconSort } from './IconSort';
import DropdownMulti from './DropdownMulti';
import SelectedFilters from './SelectedFilters';
import DropdownSingle from './DropdownSingle';

const btnSection = css`
  display: grid;
  justify-content: end;
  grid-template-columns: auto auto auto;
  column-gap: 10px;
  width: 100%;
  position: relative;
`;

const filterBtn = css`
  padding: 0 3px 0 0;
  font-family: inherit;
  font-size: 0.95em;
`;

const menuBtn = (params) => css`
  text-decoration: underline;
  color: ${params.textColor};
  background: transparent;
  cursor: pointer;
  border: 0;
  outline: none;
  display: flex;
   & svg {
     margin-left: 5px;
   }
`;

const dropdownWrapper = (params) => css`
  position: relative;
  display: flex;
  &:before {
    content: '';
    position: absolute;
    height: 14px;
    background: ${params.textColor};
    width: 1px;
    left: 0;
    z-index: 900;
    top: calc(50% - 7px);
  }
`;

const sortBtn = (params) => css`
  background: transparent;
  padding: 10px ${params?.alignLeft ? '12px' : '0'} 10px 20px;
  border: 1px solid transparent;
  font-family: inherit;
  font-size: 0.95em;
`;

const menuSection = css`
  position: relative;
  align-self: center;
`;

const FilterContainer = ({
  isFilterExpanded,
  filters,
  filtersData = {},
  config,
  themeConfig: {
    topLevelBubbles,
    bubbles,
    navBar,
    singleDropdown,
  },
  themeConfig,
  onSortToggle,
  onDateToggle,
  onFilterChange,
  isSortExpanded,
  isDateExpanded,
  hasFilterChanged,
  onFiltersToggle,
  isLoading,
  onReset,
}) => (
  <>
    <div className={btnSection}>
      {(!isEmpty(filters?.multiSelect) || filters?.gender || filters?.subscriptions) && (
        <>
          <div className={menuSection}>
            <button
              type="button"
              className={cx(menuBtn(navBar), filterBtn)}
              onClick={onFiltersToggle}
            >
              Filter by
              {isFilterExpanded
                ? <ChevronUp width={20} height={14} viewBox="0 7 20 7" />
                : <ChevronDown width={20} height={14} viewBox="0 7 20 7" />}
            </button>
          </div>
          {isFilterExpanded && (
            <DropdownMulti
              isLoading={isLoading}
              filters={filters}
              filtersData={filtersData}
              onChange={onFilterChange}
              onReset={onReset}
              themeConfig={themeConfig}
              isDynamic={config.enableDynamicSearch}
              hasFilterChanged={hasFilterChanged}
              filterOrder={config.filterOptionsOrder || []}
            />
          )}
          <SelectedFilters
            onBubblesToggle={onFiltersToggle}
            enableTopLevelBubble={config.enableTopLevelBubblesToggle}
            filters={filters?.multiSelect}
            themeConfig={topLevelBubbles || bubbles}
            filterOrder={config.filterOptionsOrder || []}
          />
        </>
      )}
      <div className={dropdownWrapper(navBar)}>
        {filters?.date && (
          <div className={menuSection}>
            <button
              type="button"
              className={cx(menuBtn(navBar), sortBtn({ alignLeft: true }))}
              onClick={onDateToggle}
            >
              Date Range
              <Calendar size={16} />
            </button>
            {isDateExpanded && (
              <DropdownSingle
                filter={filters?.date}
                themeConfig={{ ...singleDropdown, isActive: isDateExpanded }}
                onChange={onFilterChange}
                title="Date Range"
                icon={<Calendar size={16} />}
                onToggleMenu={onDateToggle}
              />
            )}
          </div>
        )}
        {filters?.sort?.options && (
          <div className={menuSection}>
            <button
              type="button"
              className={cx(menuBtn(navBar), sortBtn())}
              onClick={onSortToggle}
            >
              Sort by
              <IconSort />
            </button>
            {isSortExpanded && (
              <DropdownSingle
                filter={filters?.sort}
                themeConfig={{ ...singleDropdown, isActive: isSortExpanded }}
                onChange={onFilterChange}
                title="Sort by"
                icon={<IconSort />}
                onToggleMenu={onSortToggle}
              />
            )}
          </div>
        )}
      </div>
    </div>
  </>
);

FilterContainer.propTypes = {
  config: PropTypes.object,
  themeConfig: PropTypes.object,
  onFilterChange: PropTypes.func,
  filters: PropTypes.object,
  filtersData: PropTypes.object,
  isFilterExpanded: PropTypes.bool,
  isSortExpanded: PropTypes.bool,
  isDateExpanded: PropTypes.bool,
  onFiltersToggle: PropTypes.func,
  onDateToggle: PropTypes.func,
  onSortToggle: PropTypes.func,
  onReset: PropTypes.func,
  hasFilterChanged: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default FilterContainer;
